import React from 'react';

import IconButton from '@material-ui/core/IconButton';

import { SdmTypography } from '.';
import { theme } from '../theme';
import { styled } from '@material-ui/core/styles';

const variants = {
  red: {
    border: '1px solid ' + theme.colors.primary.red,
    color: theme.colors.primary.red,
    '&:hover': {
      background: 'transparent !important',
    },
    '&:disabled': {
      color: theme.colors.greyScale.grey3,
      background: 'transparent !important',
      opacity: 0.23,
    },
  },
  redFill: {
    background: theme.colors.primary.red,
    color: `${theme.colors.greyScale.white} !important`,
    '&:hover': {
      color: theme.colors.dark.red,
      background: theme.colors.light.red,
    },
    '&:disabled': {
      color: theme.colors.greyScale.white,
      background: theme.colors.light.red + ' !important',
      opacity: 0.23,
    },
  },
  redFillStatic: {
    background: theme.colors.primary.red,
    color: theme.colors.greyScale.white,
    '&:hover': {
      background: `${theme.colors.primary.red} !important`,
    },
  },
  whiteFill: {
    background: theme.colors.primary.white,
    color: theme.colors.primary.red,
    '&:hover': {
      color: theme.colors.dark.red,
      background: theme.colors.primary.white,
      opacity: 0.85,
    },
    '&:disabled': {
      color: theme.colors.dark.red,
      background: theme.colors.primary.white + ' !important',
      opacity: 0.5,
    },
  },
  none: {
    border: 'none',
    color: theme.colors.primary.grey,
    '&:hover': {
      background: 'transparent !important',
      color: theme.colors.primary.black,
    },
    '&:disabled': {
      color: theme.colors.primary.grey,
      background: 'transparent !important',
      // opacity: 0.23,
    },
  },
  noneWhite: {
    border: 'none',
    color: theme.colors.primary.white,
    '&:hover': {
      background: 'transparent !important',
      color: theme.colors.primary.grey,
    },
    '&:disabled': {
      color: theme.colors.primary.grey,
      background: 'transparent !important',
      // opacity: 0.23,
    },
  },
  noneRed: {
    border: 'none',
    color: theme.colors.primary.red,
    '&:hover': {
      background: 'transparent !important',
      color: theme.colors.primary.grey,
    },
    '&:disabled': {
      color: theme.colors.primary.grey,
      background: 'transparent !important',
      // opacity: 0.23,
    },
  },
  noneInverted: {
    border: 'none',
    color: theme.colors.primary.black,
    '&:hover': {
      background: 'transparent !important',
      color: theme.colors.primary.grey,
    },
    '&:disabled': {
      color: theme.colors.primary.grey,
      background: 'transparent !important',
      // opacity: 0.23,
    },
  },
  black: {
    border: ` 1px solid ${theme.colors.primary.black}`,
    color: theme.colors.primary.black,
    backgroundColor: theme.colors.primary.white,
    height: 30,
  },
  grey: {
    color: theme.colors.greyScale.grey1,
    backgroundColor: 'rgba(145, 158, 171, 0.24)',
  },
};

const CustomIconButton = styled(IconButton)(
  ({ variant = 'redFill', height = false, customBorder = false }) => ({
    borderRadius: 0,
    height: height || 64,
    minWidth: 90,
    margin: 4,
    padding: '8px 16px',
    cursor: 'pointer',
    position: 'relative',
    ...variants[variant],
    ...customBorder,
  })
);

const CustomButton = (
  {
    text,
    textVariant = false,
    isUpperCase = false,
    isUnderline = false,
    positionArrow = 'left',
    positionArrowPx = 0,
    positionArrowTop = 4,
    customStyle = {},
    textStyle,
    children,
    ...rest
  },
  ref
) => (
  <CustomIconButton ref={ref} {...rest} disableRipple disableFocusRipple>
    <div
      style={{
        position: 'absolute',
        marginTop: positionArrowTop,
        [`${positionArrow}`]: positionArrowPx,
        ...customStyle,
      }}
    >
      {children}
    </div>
    {text && (
      <SdmTypography
        variant={textVariant || 'text'}
        style={{
          textTransform: isUpperCase ? 'uppercase' : 'none',
          textDecoration: isUnderline ? 'underline' : 'none',
          ...textStyle,
        }}
      >
        {text}
      </SdmTypography>
    )}
  </CustomIconButton>
);

CustomButton.displayName = 'SdmTextButton';

export const SdmTextButton = React.forwardRef(CustomButton);
